// extracted by mini-css-extract-plugin
export default {"label":"styles_label__Y5sch","span":"styles_span__QfzTq","input":"styles_input__Uh0KI"};